import { PartialType } from '../../../../utils';
import { CreateHourly24InsuranceFeeDto } from './create-hourly-24-insurance-fee.dto';
export class UpdateHourly24InsuranceFeeDto extends PartialType(CreateHourly24InsuranceFeeDto) {
}
